/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Lock } from 'lucide-react';

/**
 * Reflection Note™ — sacred private artifact.
 *
 * Visible only to the counselor themselves. Never to admin, terra_head,
 * mentors, peers, war room, or any system summary. The system never
 * analyses, classifies, or summarises these notes.
 *
 * Optional. Never required. Never prompted. Never notified.
 */
export default function ReflectionNoteInput({ signalKey, weekIso, initial = '' }) {
  const [note, setNote] = useState(initial || '');
  const [savedAt, setSavedAt] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const tRef = useRef(null);

  useEffect(() => { setNote(initial || ''); }, [initial]);

  const onChange = (v) => {
    setNote(v);
    if (tRef.current) clearTimeout(tRef.current);
    tRef.current = setTimeout(() => save(v), 900);
  };

  const save = async (v) => {
    setSaving(true);
    try {
      await axios.put(`${API}/sustainability/notes`, {
        signal_key: signalKey,
        week_iso:   weekIso,
        note:       v,
      });
      setSavedAt(new Date());
    } catch { /* silent — never alarm */ }
    finally { setSaving(false); }
  };

  return (
    <div data-testid={`reflection-note-${signalKey}`}
          className={`mt-2 transition-all ${hasFocus ? 'opacity-100' : 'opacity-70 hover:opacity-100'}`}>
      <label className="text-[10px] uppercase tracking-[0.16em] text-[#8C6239] flex items-center gap-1 mb-1">
        <Lock className="w-2.5 h-2.5" /> Reflection note · private
      </label>
      <input
        data-testid={`reflection-note-input-${signalKey}`}
        type="text"
        value={note}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onChange={(e) => onChange(e.target.value.slice(0, 280))}
        maxLength={280}
        placeholder="optional reflective anchoring…"
        className="w-full bg-transparent border-b border-[#E5D6BE] focus:border-[#8C6239] outline-none text-[12px] text-[#5C3D1F] placeholder:text-[#B5B0A8] py-1 transition-colors"
      />
      <p className="text-[9px] text-[#B5B0A8] italic mt-1">
        {saving ? 'saving…' : (savedAt ? 'saved · only you see this' : 'only you see this')}
      </p>
    </div>
  );
}
